import Layout from '@/common/Layout';
import { ArrowLeftOutlined } from '@ant-design/icons';
import FloatingActionButton from 'pages/FloatingActionButton';
import { useNavigate } from 'react-router-dom';
import { getLoggedInUser } from 'utilities/helpers';
import { MANAGER } from 'utilities/roleRights';
import ActionCard from './components/ActionCard';
import {
  faBuilding,
  faFolderTree,
  faUsersGear
} from '@fortawesome/free-solid-svg-icons';
import { Button } from 'antd';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getActiveCounts, selectConfigureSlice } from './redux/slice';
import CustomButton from '@/common/CustomButton';

export const cards = [
  {
    label: 'Manage Clients',
    description:
      'Add, edit, or remove client organizations and manage their details',
    color: '!text-blue-600',
    bgColor: '!bg-blue-100',
    counts: '12 Active Clients',
    icon: faBuilding,
    to: 'clients'
  },
  {
    label: 'Manage Projects',
    description: 'Create and organize projects, set timelines and assign teams',
    color: '!text-purple-600',
    bgColor: '!bg-purple-100',
    counts: '12 Active Projects',
    icon: faFolderTree,
    to: 'projects'
  },
  {
    label: 'Manage Users',
    description: 'Add team members, set roles and manage permissions',
    color: '!text-green-600',
    bgColor: '!bg-green-100',
    counts: '12 Active Users',
    icon: faUsersGear,
    to: 'users'
  }
];

export default function Configure() {
  const user = getLoggedInUser();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [counts, setCounts] = useState({});
  const { loading } = useSelector(selectConfigureSlice);

  useEffect(() => {
    dispatch(getActiveCounts()).then((res) => {
      if (res?.payload?.success) {
        setCounts(res?.payload?.data);
      }
    });
  }, []);

  const cards = [
    {
      label: 'Manage Clients',
      description:
        'Add, edit, or remove client organizations and manage their details',
      color: '!text-blue-600',
      bgColor: '!bg-blue-100',
      counts: `${counts?.active_clients} Active Clients`,
      icon: faBuilding,
      to: 'clients'
    },
    {
      label: 'Manage Projects',
      description:
        'Create and organize projects, set timelines and assign teams',
      color: '!text-purple-600',
      bgColor: '!bg-purple-100',
      counts: `${counts?.active_projects} Active Projects`,
      icon: faFolderTree,
      to: 'projects'
    },
    {
      label: 'Manage Users',
      description: 'Add team members, set roles and manage permissions',
      color: '!text-green-600',
      bgColor: '!bg-green-100',
      counts: `${counts?.active_users} Active Users`,
      icon: faUsersGear,
      to: 'users'
    }
  ];

  return (
    <Layout sider={false}>
      <div
        className="flex flex-col gap-6"
        // style={{ fontFamily: 'SFProText Regular' }}
      >
        <div className="flex justify-end sm:hidden">
          <CustomButton type="outlined" onClick={() => navigate('/dashboard')}>
            <ArrowLeftOutlined /> Back to Dashboard
          </CustomButton>
        </div>
        {/* header */}
        <div className="flex items-center justify-between">
          <div className="flex flex-col gap-1">
            <label className={'!text-xl md:!text-3xl !font-bold md:mt-0 mt-2'}>
              Configuration
            </label>
            <p className="!text-gray-500 text-sm !font-semibold">
              Manage your organization&apos;s clients, projects and user
              settings
            </p>
          </div>

          <CustomButton
            className={'hidden sm:block'}
            type="outlined"
            onClick={() => navigate('/dashboard')}
          >
            <ArrowLeftOutlined /> Back to Dashboard
          </CustomButton>
        </div>
        {/* cards */}
        <div className="grid grid-cols-1 gap-6 mb-4 md:grid-cols-3 xl:grid-cols-4 h-fit">
          {cards.map((card) => {
            return (
              <ActionCard
                onClick={() => navigate(card.to)}
                data={card}
                key={card.label}
                loading={loading}
              />
            );
          })}
        </div>
      </div>
      {/* new task modal */}
      {user?.user_details?.role_id === MANAGER ? <FloatingActionButton /> : ''}
    </Layout>
  );
}
